module.exports = __webpack_public_path__ + "img/register-dark.e0809156.svg";